module.exports = {"header":"xxx","subheader":"xxx","vwType":"xxx","vwText":"xxx","qType":"xxx","qText":"xxx","jhType":"xxx","jhText":"xxx","apmpType":"xxx","apmpText":"xxx","gwType":"xxx","gwText":"xxx","otherTitle":"Other references","otherText":"We've also helped these companies with miscellaneous web projects"}


//////////////////
// WEBPACK FOOTER
// ./src/app/case/lang/en.lang.json
// module id = 334
// module chunks = 1